<template>
	<NuxtLayout name="default">
		<div
			class="content"
			:class="[bgClass, props.error!.statusCode < 500 ? 'bg_position_green' : 'bg_position_blue']"
		>
			<div class="info">
				<h3 class="error_code">{{ props.error!.statusCode }} {{ $t("pages.error.error") }}</h3>
				<h2 class="error_message">
					{{
						props.error!.statusCode! >= 400 && props.error!.statusCode! < 500
							? $t("pages.error.page_not_found")
							: $t("pages.error.internal_error")
					}}
				</h2>
				<p
					v-if="props.error!.data && !isJSONString(props.error!.data)"
					class="suggested_operation"
				>
					{{ props.error!.data }}
				</p>
				<p
					v-else
					class="suggested_operation"
				>
					{{
						props.error!.statusCode >= 400 && props.error!.statusCode < 500
							? $t("pages.error.page_not_exist")
							: $t("pages.error.something_wrong")
					}}
					<br />
					{{
						props.error!.statusCode >= 400 && props.error!.statusCode < 500
							? $t("pages.error.check_url")
							: $t("pages.error.refresh_page")
					}}
				</p>
				<Button
					color="primary"
					size="large"
					@click="handleClearError"
				>
					{{ $t("pages.error.back_to_homepage") }}
				</Button>
			</div>
		</div>
	</NuxtLayout>
</template>
<script lang="ts" setup>
import type { NuxtError } from "#app";

const props = defineProps({ error: Object as () => NuxtError });

const bgImage = computed(() => {
	if (props.error!.statusCode >= 400 && props.error!.statusCode < 500) {
		return "url(/images/400.png)";
	} else {
		return "url(/images/500.png)";
	}
});

const bgClass = computed(() => {
	if (window.location.host.includes("system") || window.location.host.includes(":5035")) {
		return "dark_bg";
	}
	return "light_bg";
});

function handleClearError() {
	clearError({ redirect: "/" });
}

function isJSONString(str: any) {
	try {
		JSON.parse(str);
		return true;
	} catch (e) {
		return false;
	}
}

/*
	data: a field can be used to show custom content in error page
*/
// throw createError({
// 	statusCode: 500,
// 	statusMessage: "Internal Server Error",
// 	data: "Custom error content",
// 	fatal: true, // render error page when error is created in browser (not server)
// });
</script>
<style lang="scss" scoped>
$content-bg-image: v-bind(bgImage);

.content {
	@apply text-neutral-900 mt-[16px] w-full h-[681px];

	.info {
		@apply ml-[13%] w-[40%] pt-[10%] mobile:w-[75%] mobile:pt-[66px];

		.error_code {
			@apply text-[20px] leading-[30px];
		}

		.error_message {
			@apply text-[60px] leading-[67px] mb-[28px];
			@screen mobile {
				@apply text-[36px] leading-[40px];
			}
		}

		.suggested_operation {
			@apply text-[16px] leading-[24px] mb-[70px];
		}
	}
}

.bg_position_green {
	@media (max-width: 800px) {
		background-position: 87.5% 50%;
	}
}

.bg_position_blue {
	@media (max-width: 800px) {
		background-position: 52.5% 50%;
	}
}

.dark_bg {
	background: $content-bg-image, linear-gradient(0deg, rgba(26, 75, 125, 0.05) 0%, rgba(26, 75, 125, 0.05) 100%),
		#f5f5f5;
	background-repeat: no-repeat;
	background-size: cover;
}

.light_bg {
	background: $content-bg-image, #fff;
	background-repeat: no-repeat;
	background-size: cover;
}
</style>
